module.exports = __webpack_public_path__ + "static/media/dashboard-search.3e0c4457.svg";